import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { FileItem } from 'ng2-file-upload';
import { KeycloakService } from '../services/keycloak.service';

// tslint: disable
/**
 * Credits goes to [josecarlosaparicio](https://github.com/valor-software/ng2-file-upload/issues/671)
 */
export class MultiFileUploader extends FileUploader {
  private authRealm: string;

  constructor(options: FileUploaderOptions) {
    super(options);
  }

  uploadItem(value: FileItem): void {
    this._setToken();
    super.uploadItem(value);
  }

  uploadAll(): void {
    // this._setToken();
    // super.uploadAll();
    this.uploadAllFiles();
  }

  uploadAllFiles(): void {
    this._setToken();
    const xhr = new XMLHttpRequest();
    const sendable = new FormData();
    const fakeitem: FileItem = null;
    this.onBuildItemForm(fakeitem, sendable);

    const items: any[] = [];
    for (const item of this.queue) {
      item.isReady = true;
      item.isUploading = true;
      item.isUploaded = false;
      item.isSuccess = false;
      item.isCancel = false;
      item.isError = false;
      item.progress = 0;
      items.push(item);
      if (typeof item._file.size !== 'number') {
        throw new TypeError('The file specified is no longer valid');
      }
      sendable.append('data', item._file, item.file.name);
    }
    this.onBeforeUploadItem(items as any);

    xhr.onload = () => {
      const gist = (xhr.status >= 200 && xhr.status < 300) || xhr.status === 304 ? 'Success' : 'Error';
      const method = 'on' + gist + 'Item';
      ((this as any)[method] as any)(fakeitem, null, xhr.status, null);
      this.onCompleteItem(items as any, xhr.response, xhr.status, xhr.getAllResponseHeaders() as any);
    };
    xhr.onerror = () => {
      this.onErrorItem(items as any, xhr.response, xhr.status, xhr.getAllResponseHeaders() as any);
    };

    xhr.onabort = () => {
      this.onErrorItem(items as any, xhr.response, xhr.status, xhr.getAllResponseHeaders() as any);
    };

    xhr.open('POST', this.options.url, true);
    xhr.withCredentials = true;
    if (this.options.headers) {
      for (let _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
        const header = _a[_i];
        xhr.setRequestHeader(header.name, header.value);
      }
    }
    if (this.authToken) {
      xhr.setRequestHeader('Authorization', this.authToken);
    }
    xhr.send(sendable);
  }

  private _setToken() {
    this.authToken = `Bearer ${KeycloakService.auth.authz.token}`;
    this.authRealm = KeycloakService.auth.authz.realm;
  }
}
